<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="满意度调查" name="satisfy">
        <el-button size="small" type="primary" @click="satisfyAdd()"
          >添加</el-button
        >
        <el-table
          :data="satisfyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="年份" width="120">
            <template slot-scope="scope">
              <span>{{
                scope.row.year
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="季度" width="120">
            <template slot-scope="scope">
              <span>{{
                scope.row.quarter
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="十分满意次数_业主" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.ten_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="满意次数_业主" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="一般次数_业主" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.general_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="待改进次数_业主" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.wait_improve_satisfied_yz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不满意次数_业主" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.no_satisfied_yz }}</span>
            </template>
          </el-table-column>

          <el-table-column label="十分满意次数_工作人员" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.ten_satisfied_gr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="满意次数_工作人员" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.satisfied_gr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="一般次数_工作人员" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.general_satisfied_gr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="待改进次数_工作人员" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.wait_improve_satisfied_gr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不满意次数_工作人员" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.no_satisfied_gr }}</span>
            </template>
          </el-table-column>


          <el-table-column label="十分满意占比" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.ten_satisfied_percent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="满意占比" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.satisfied_percent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="一般占比" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.general_satisfied_percent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="待改进占比" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.wait_improve_percent }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不满意占比" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.no_satisfied_percent }}</span>
            </template>
          </el-table-column>


          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="satisfySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="satisfyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="satisfyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 满意度添加 -->
    <el-dialog
      :title="satisfyTitle"
      :visible.sync="satisfyFormVisible"
      width="800px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        style="max-height: 400px; overflow: auto"
        label-width="160px"
        :model="satisfyForm"
        ref="satisfyForm"
      >
        <el-form-item
          label="年份"
          prop="year"
          :rules="{
            required: true,
            message: '请输入年份',
            trigger: 'change',
          }"
        >
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.year"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入年份"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="季度"
          prop="quarter"
          :rules="{
            required: true,
            message: '请输入季度',
            trigger: 'change',
          }"
        >
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            :max="4"
            :min="1"
            v-model.number="satisfyForm.quarter"
            placeholder="请输入季度"
          ></el-input>
        </el-form-item>
        <el-form-item label="投诉率" prop="complaint_rate">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.complaint_rate"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入投诉率"
          ></el-input>
        </el-form-item>

        <el-form-item label="十分满意次数_业主" prop="ten_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.ten_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入十分满意次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="满意次数_业主" prop="satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入满意次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="一般次数_业主" prop="general_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.general_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入一般次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="待改进次数_业主" prop="wait_improve_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.wait_improve_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入待改进次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item label="不满意次数_业主" prop="no_satisfied_yz">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.no_satisfied_yz"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入不满意次数_业主"
          ></el-input>
        </el-form-item>

        <el-form-item label="十分满意次数_工作人员" prop="ten_satisfied_gr">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.ten_satisfied_gr"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入十分满意次数_工作人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="满意次数_工作人员" prop="satisfied_gr">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.satisfied_gr"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入满意次数_工作人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="一般次数_工作人员" prop="general_satisfied_gr">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.general_satisfied_gr"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入一般次数_业主"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="待改进次数_工作人员"
          prop="wait_improve_satisfied_gr"
        >
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.wait_improve_satisfied_gr"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入待改进次数_工作人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="不满意次数_工作人员" prop="no_satisfied_gr">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.no_satisfied_gr"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入不满意次数_工作人员"
          ></el-input>
        </el-form-item>

        <el-form-item label="十分满意占比" prop="ten_satisfied_percent">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.ten_satisfied_percent"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入十分满意占比"
          ></el-input>
        </el-form-item>
        <el-form-item label="满意占比" prop="satisfied_percent">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.satisfied_percent"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入满意占比"
          ></el-input>
        </el-form-item>
        <el-form-item label="一般占比" prop="general_satisfied_percent">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.general_satisfied_percent"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入一般占比"
          ></el-input>
        </el-form-item>
        <el-form-item label="待改进占比" prop="wait_improve_percent	">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.wait_improve_percent"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入待改进占比"
          ></el-input>
        </el-form-item>
        <el-form-item label="不满意占比" prop="no_satisfied_percent">
          <el-input
            type="Number"
            :disabled="satisfyCz == 'see'"
            class="numInput"
            v-model.number="satisfyForm.no_satisfied_percent"
            οninput="value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入不满意占比"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="satisfyFormVisible = false">取消</el-button>
        <el-button
          v-if="satisfyCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="satisfySubmit('satisfyForm')"
          >添加</el-button
        >
        <el-button
          v-if="satisfyCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="satisfyTjEdit('satisfyForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  wcSzglSatisfyList,
  wcSzglSatisfyDetail,
  wcSzglSatisfyDel,
  wcSzglSatisfyEdit,
  wcSzglSatisfyAdd,
} from "@/api/wuchang";
export default {
  components: {},
  data() {
    return {
      loading: false, //是显示加载
      activeName: "satisfy",
      // 能耗
      energyData: [],
      energyForm: {
        type: "",
        value: [],
      },
      energyFormVisible: false,
      energyTitle: "添加",
      energyCz: "",
      energyRules: {
        // type: [
        //   { required: true, message: "请输入项目名称", trigger: "blur" },
        // ],
        value: [{ required: true, message: "请输入配置信息", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      oldEnergyForm: {},
      // 值班人员
      dutyData: [],
      dutyForm: {},
      dutyCz: "",
      dutyRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        duty_hours: [
          { required: true, message: "请输入值班时间", trigger: "blur" },
        ],
        location: [{ required: true, message: "请输入地点", trigger: "blur" }],
      },
      dutyTitle: "",
      dutyFormVisible: false,
      dutyPage: 1,
      dutyTotal: 0,
      dutySize: 15,

      satisfyData: [],
      satisfyTitle: "添加",
      satisfyCz: "add",
      satisfyFormVisible: false,
      satisfyForm: {},
      satisfyPage: 1,
      satisfyTotal: 0,
      satisfySize: 15,
    };
  },
  computed: {},
  mounted() {
    this.getSatisfyList();
  },
  methods: {
    // 重点项目宣传-详情
    satisfyInfo(id) {
      wcSzglSatisfyDetail({ id: id }).then((res) => {
        this.satisfyForm = {
          id: res.data.id,
          ten_satisfied_yz: res.data.ten_satisfied_yz,
          satisfied_yz: res.data.satisfied_yz,
          general_satisfied_yz: res.data.general_satisfied_yz,
          wait_improve_satisfied_yz: res.data.wait_improve_satisfied_yz,
          no_satisfied_yz: res.data.no_satisfied_yz,

          ten_satisfied_gr: res.data.ten_satisfied_gr,
          satisfied_gr: res.data.satisfied_gr,
          general_satisfied_gr: res.data.general_satisfied_gr,
          wait_improve_satisfied_gr: res.data.wait_improve_satisfied_gr,
          no_satisfied_gr: res.data.no_satisfied_gr,


        ten_satisfied_percent:res.data.ten_satisfied_percent,
        satisfied_percent:res.data.satisfied_percent,
        general_satisfied_percent:res.data.general_satisfied_percent,
        wait_improve_percent:res.data.wait_improve_percent,
        no_satisfied_percent:res.data.no_satisfied_percent,
        year:res.data.year,
        quarter:res.data.quarter,
        };
      });
    },
    // 表格编辑操作
    satisfyEdit(val) {
      this.satisfyTitle = "编辑";
      this.satisfyCz = "edit";
      this.satisfyInfo(val.id);
      this.satisfyFormVisible = true;
    },
    // 表格查看操作
    satisfySee(val) {
      this.satisfyTitle = "查看";
      this.satisfyCz = "see";
      this.satisfyInfo(val.id);
      this.satisfyFormVisible = true;
    },

    // 满意度调查-删除
    satisfyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcSzglSatisfyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getSatisfyList();
          });
        })
        .catch(() => {});
    },
    // 满意度调查-新增
    satisfySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          wcSzglSatisfyAdd(that.satisfyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getSatisfyList();
              that.satisfyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 满意度调查-编辑
    satisfyTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          wcSzglSatisfyEdit(that.satisfyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getSatisfyList();
              that.satisfyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加满意度调查
    satisfyAdd() {
      this.satisfyFormVisible = true;
      this.satisfyTitle = "添加";
      this.satisfyCz = "add";
      this.satisfyForm = {
        ten_satisfied_yz: "",
        satisfied_yz: "",
        general_satisfied_yz: "",
        wait_improve_satisfied_yz: "",
        no_satisfied_yz: "",
        ten_satisfied_gr: "",
        satisfied_gr: "",
        general_satisfied_gr: "",
        wait_improve_satisfied_gr: "",
        no_satisfied_gr: "",
        ten_satisfied_percent:'',
        satisfied_percent:'',
        general_satisfied_percent:'',
        wait_improve_percent:'',
        no_satisfied_percent:'',
        year:'',
        quarter:'',
      };
    },
    // 获取满意度调查
    getSatisfyList() {
      wcSzglSatisfyList().then((res) => {
        this.satisfyData = res.data;
      });
    },

    // 重点项目分页
    handleSizeChange(val) {
      this.dutySize = val;
      this.getDutyList();
    },
    // 重点项目分页
    handleCurrentChange(val) {
      this.dutyPage = val;
      this.getDutyList();
    },
   

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dutyFormVisible = false;

      this.energyFormVisible = false;
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getSatisfyList();
      }
      // if (tab.index == 0) {
      //   this.getEnergyList();
      // } else if (tab.index == 1) {
      //   this.getDutyList();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}


::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
